export default {
  viewBox: "0 0 24 24",
  html: "<path fill=\"#222B33\" fill-rule=\"evenodd\" d=\"M19.75 19.75H4.25V4.25h15.5zM5 3c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z\" clip-rule=\"evenodd\"/>"
};